export const LeaderPortrait = ({ person, large = false }) => {
  const initials = person.name
    .replace("Barr. ", "")
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <div
      data-testid={`leader-portrait-${person.slug}`}
      className={`relative overflow-hidden rounded-[2rem] border border-white/10 bg-gradient-to-br from-blue-500/25 via-[#141E33] to-amber-400/20 ${large ? "aspect-[4/5] w-full" : "h-32 w-32"}`}
    >
      {person.photo ? (
        <img src={person.photo} alt={`${person.name} portrait`} className="h-full w-full object-cover" />
      ) : (
        <div className="flex h-full w-full items-center justify-center">
          <div className={`${large ? "h-44 w-44" : "h-20 w-20"} rounded-full border border-amber-400/30 bg-[#070C14]/70 backdrop-blur-xl flex items-center justify-center`}>
            <span className={`${large ? "text-6xl" : "text-2xl"} font-heading font-bold text-white`}>{initials}</span>
          </div>
        </div>
      )}
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-[#070C14]/80 to-transparent" />
    </div>
  );
};
